import { Text, createStyles } from '@mantine/core';

import Image from 'next/image';
import { images } from '@/utils/images';
import { isDark } from '@/utils/utils';
import themeVariables from '@/styles/themeVariables';

const useEmptyResultCardStyle = createStyles((_, dark) => ({
  container: {
    padding: '40px 0px',
    textAlign: 'center',
  },

  animation: {
    height: 140,
  },

  text: {
    marginTop: 40,
    fontSize: 14,
    color: dark?.dark
      ? themeVariables.label.normalDark
      : themeVariables.fontColors.light,
  },
}));

const EmptyResultCard = ({ title }) => {
  const { dark } = isDark();
  const { classes } = useEmptyResultCardStyle({ dark });

  return (
    <div className={classes.container}>
      <Image
        width={200}
        height={200}
        src={images.ghost}
        alt="empty"
        priority
        style={{
          backgroundColor: dark
            ? themeVariables.colors.light300
            : 'transparent',
          borderRadius: 4,
        }}
      />
      <Text className={classes.text}>{title}</Text>
    </div>
  );
};

export default EmptyResultCard;
